import React from 'react'
import { Box, Divider, Typography } from '@mui/material'

import {
  StyledSection,
  StyledContainer,
  StyledHeaderBox,
  StyledMainTitle,
  StyledHeaderDescription,
  SubSection,
  StyledPaper,
} from '../styled.jsx'

export const TypographyComponents = () => {
  const headingVariants = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6']
  const subtitleVariants = ['subtitle1', 'subtitle2']
  const bodyVariants = ['body1', 'body2']
  const miscVariants = ['button', 'caption', 'overline']

  const renderVariantRow = (variant, text) => (
    <Box key={variant} sx={{ display: 'flex', alignItems: 'baseline', gap: 2 }}>
      <Typography variant='caption' sx={{ width: 96, color: 'text.secondary' }}>
        {variant}
      </Typography>
      <Typography variant={variant}>{text}</Typography>
    </Box>
  )

  return (
    <StyledSection>
      <StyledContainer>
        <StyledHeaderBox>
          <StyledMainTitle variant='h4' gutterBottom>
            Typography Reference
          </StyledMainTitle>
          <StyledHeaderDescription variant='body1'>
            Preview of theme typography variants. Use this as a visual guide
            while building UI.
          </StyledHeaderDescription>
        </StyledHeaderBox>

        <SubSection title='Headings'>
          <StyledPaper>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              {headingVariants.map(v =>
                renderVariantRow(
                  v,
                  'The quick brown fox jumps over the lazy dog'
                )
              )}
            </Box>
          </StyledPaper>
        </SubSection>

        <SubSection title='Subtitles'>
          <StyledPaper>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              {subtitleVariants.map(v =>
                renderVariantRow(v, 'Supportive subtitle text goes here')
              )}
            </Box>
          </StyledPaper>
        </SubSection>

        <SubSection title='Body Text'>
          <StyledPaper>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              {bodyVariants.map(v =>
                renderVariantRow(
                  v,
                  'Lorem ipsum dolor sit amet, consectetur adipiscing elit.'
                )
              )}
            </Box>
          </StyledPaper>
        </SubSection>

        <SubSection title='Miscellaneous'>
          <StyledPaper>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              {miscVariants.map(v =>
                renderVariantRow(v, 'Auxiliary text and labels')
              )}
            </Box>
          </StyledPaper>
        </SubSection>
      </StyledContainer>
    </StyledSection>
  )
} // end
